import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface ResponsiveDialogProps {
  title: string;
  text: string;
  cb: (answer: boolean) => void;
  fullScreen?: boolean;
}

function ModalPrompt(props: ResponsiveDialogProps) {
  const { t } = useTranslation();
  const { title, text, cb, fullScreen } = props;
  const handleClose = (answer: boolean) => cb(answer);

  return (
    <Dialog
      fullScreen={fullScreen}
      open
      onClose={() => handleClose(false)}
      aria-labelledby="responsive-dialog-title">
      <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="primary">
          {t('no')}
        </Button>
        <Button onClick={() => handleClose(true)} color="primary" autoFocus>
          {t('yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModalPrompt;
